import './App.css';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter, Routes, Route, Navigate } from "react-router";

//Importing components from ./pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ExecutiveBoard from './pages/ExecutiveBoard';
import Conferences from './pages/Conferences';
import OurHistory from './pages/OurHistory';
import Shungubug from './pages/Shungubug';
import Guachtuq from './pages/Guachtuq';
import ElCisne from './pages/ElCisne';
import GetInvolved from './pages/GetInvolved';
import Events from './pages/Events';
import Sponsors from './pages/Sponsors';
import Donate from './pages/Donate';


function App() {
  return (
    <div class="app">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path={"/"} element={<Home />} />
            <Route path={"/AboutUs"} element={<AboutUs />} />
            <Route path={"/ExecutiveBoard"} element={<ExecutiveBoard />} />
            <Route path={"/Conferences"} element={<Conferences />} />
            <Route path={"/OurHistory"} element={<OurHistory />} />
            <Route path={"/Shungubug"} element={<Shungubug />} />
            <Route path={"/Guachtuq"} element={<Guachtuq />} />
            <Route path={"/ElCisne"} element={<ElCisne />} />
            <Route path={"/GetInvolved"} element={<GetInvolved />} />
            <Route path={"/Events"} element={<Events />} />
            <Route path={"/Sponsors"} element={<Sponsors />} />
            <Route path={"/Donate"} element={<Donate />} />
            <Route path={"/Home"} element={<RedirectHome />} />
            <Route path={"*"} element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

//This "page" simply redirects to home.
function RedirectHome(){
  return <Navigate to="/" replace />;
}

//This "page" simply redirects to home.
function NotFound(){
  return <Navigate to="/" replace />;
}

export default App;
